import { useState } from 'react';
import { useModalAnimation } from '@/hooks/useModalAnimation';

interface DeleteUserModalProps {
  userName: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export default function DeleteUserModal({ userName, onClose, onConfirm }: DeleteUserModalProps) {
  const { animating, handleClose } = useModalAnimation(onClose);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm();
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className={`bg-white rounded-2xl w-full max-w-sm p-6 ${animating ? 'modal-panel-active' : 'modal-panel-enter'}`}>
        <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mx-auto mb-4">
          <i className="ri-delete-bin-line text-red-500 text-xl" />
        </div>
        <h2 className="text-base font-semibold text-slate-800 text-center mb-2">Remover Utilizador</h2>
        <p className="text-sm text-slate-500 text-center mb-6">
          Tens a certeza que queres remover <strong className="text-slate-700">{userName}</strong>? Esta ação não pode ser desfeita.
        </p>
        <div className="flex gap-3">
          <button onClick={handleClose} className="flex-1 py-2.5 text-sm font-medium text-slate-600 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer whitespace-nowrap">
            Cancelar
          </button>
          <button onClick={handleConfirm} disabled={loading} className="flex-1 py-2.5 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors disabled:opacity-60 cursor-pointer whitespace-nowrap">
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <i className="ri-loader-4-line animate-spin" />
                A remover...
              </span>
            ) : 'Remover'}
          </button>
        </div>
      </div>
    </div>
  );
}